import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  background: #0e77ff;
`;
